var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import BackendService from "./index";
import { errorHandler } from "../utils/helper";
class AuthService extends BackendService {
    constructor(apiUrl) {
        super(apiUrl);
    }
    getKey(accessToken) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const { data } = yield this.triaAxios.get("/auth/get-key", {
                    headers: {
                        'Authorization': `Bearer ${accessToken}` // Set the Authorization header with the Bearer token
                    }
                });
                return data;
            }
            catch (err) {
                return errorHandler(err);
            }
        });
    }
    logout() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const { data } = yield this.triaAxios.post("/auth/logout");
                return data;
            }
            catch (err) {
                return errorHandler(err);
            }
        });
    }
    saveOauthUser({ userOauthId, isPasswordRequired, password, platform, accessToken, triaNameHash, pin, encyRandomNumber, salt, shard, triaName }) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const { data } = yield this.triaAxios.post("/auth/save-oauth-user", {
                    triaNameHash,
                    userOauthId,
                    isPasswordRequired,
                    password,
                    platform,
                    pin,
                    encyRandomNumber,
                    salt,
                    shard,
                    triaName
                }, {
                    headers: {
                        'Authorization': `Bearer ${accessToken}` // Set the Authorization header with the Bearer token
                    }
                });
                return data;
            }
            catch (err) {
                return errorHandler(err);
            }
        });
    }
    checkLinkEmailExists({ email }) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const { data } = yield this.triaAxios.get("/auth/link/email-exists", {
                    params: { email }
                });
                return data.emailExist;
            }
            catch (err) {
                return errorHandler(err);
            }
        });
    }
    initiateCognitoAuth({ input, password, origin, isPasswordLess, verificationType }) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const { data } = yield this.triaAxios.post("/auth/cognito/initiate", {
                    input, password, origin,
                    isPasswordLess, verificationType
                });
                return data;
            }
            catch (err) {
                return errorHandler(err);
            }
        });
    }
    verifyCognitoAuth({ input, code, isPasswordLess, session, verificationType }) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const { data } = yield this.triaAxios.post("/auth/cognito/verify", {
                    input, code, isPasswordLess,
                    verificationType,
                    session
                });
                return data;
            }
            catch (err) {
                return errorHandler(err);
            }
        });
    }
    getRecoveryShard({ accessToken, pin, idToken }) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const { data } = yield this.triaAxios.post("/user/get-recovery-shard", {
                    pin,
                    idToken
                }, {
                    headers: {
                        'Authorization': `Bearer ${accessToken}` // Set the Authorization header with the Bearer token
                    }
                });
                return data;
            }
            catch (err) {
                return errorHandler(err);
            }
        });
    }
    setupPin({ accessToken, pin, idToken }) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const { data } = yield this.triaAxios.post("/user/setup-pin", {
                    pin,
                    idToken
                }, {
                    headers: {
                        'Authorization': `Bearer ${accessToken}` // Set the Authorization header with the Bearer token
                    }
                });
                return data;
            }
            catch (err) {
                return errorHandler(err);
            }
        });
    }
    isPinSetup({ accessToken, idToken }) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const { data } = yield this.triaAxios.post("/auth/isPinSetup", {
                    idToken
                }, {
                    headers: {
                        'Authorization': `Bearer ${accessToken}` // Set the Authorization header with the Bearer token
                    }
                });
                return data;
            }
            catch (err) {
                return errorHandler(err);
            }
        });
    }
}
export default AuthService;
